import { createModel } from "@/util/ModelUtil";
import { LectureType } from "@/enum/lecture/LectureType";

export default class LectureModel {
  constructor(
    public id: number = 0,
    public organizationId: number = 0,
    public title: string = "",
    public type: LectureType = LectureType.ELearning,
    public completionRate: number = 80,
    public subscribeType: string = "",
    public startedAt: string = "",
    public endedAt: string = "",
    public createdAt: string = "",
    public updatedAt: string = "",
    public lectureUserCount: number = 0,
    public lectureAverageProgressRate: number = 0,
    public isApprovalRequired: boolean = false
  ) {}

  public static create(lecture?: Lecture): LectureModel {
    return createModel<LectureModel>(LectureModel, lecture);
  }
}
